import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { axiosHelper } from '@setvi/shared/services';
import { AxiosMethods } from '@setvi/shared/enums';
import { OrderHistoryConfig } from 'pages/sales/modules/orders/hooks/useOrdersConfig/types';

export interface Pricing {
  mode: string;
  defaultMarginEnabled: boolean;
  defaultMarginPercent: number;
  _id: string;
}

export interface QuoteConfigurationDTO {
  _id: string;
  validUntil: number;
  enableEditingPrice: boolean;
  enableCRMIntegration: boolean;
  enableOrderHistory: boolean;
  enableApprovalProcess: boolean;
  enableOpportunity: boolean;
  enableShipTo: boolean;
  enableSpecialPurchaseRequest: boolean;
  enableEquipmentRequest: boolean;
  equipmentMap?: Record<string, string>;
  enableNewProspect: boolean;
  enableValidityDate: boolean;
  marginPercentage?: number;
  orderHistory?: OrderHistoryConfig;
  orderHistoryInfoMessage?: string;
  nonEditableSellTypes: string[];
  rfqToQuoteEnabled: boolean;
  pricing: Pricing;
  enableAccountSelection: boolean;
  defaultSegment: string;
  requireSegmentForProspect: boolean;
}

export const getQuoteConfig = (): UseQueryOptions<QuoteConfigurationDTO> => ({
  queryKey: ['quote_config'],
  queryFn: () =>
    axiosHelper({
      endpoint: `/quote/configuration`,
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const useQuoteConfig = ({ enabled = true }: { enabled?: boolean }) => {
  const {
    data: quoteConfig,
    error,
    isFetching
  } = useQuery({ ...getQuoteConfig(), enabled });

  return { quoteConfig, error, isFetching };
};
